import React from "react";
import { Link } from "react-router-dom";

const Domoelec = () => {
  return (
    <div className="domo-page">
      {/* Section 1: Intro + Image */}
      <section className="domo-intro">
        <div className="container">
          <div className="domo-intro-grid">
            <div className="domo-intro-left">
              <span className="domo-label">À propos</span>
              <h1>
                Qui sommes <span className="hdr-green">nous</span> ?
              </h1>
              <p>
                <strong>DOMOELEC</strong> est votre partenaire de confiance depuis plus de 13 ans dans le domaine du courant faible.
                Nous nous spécialisons dans l'installation, la maintenance et l'innovation de systèmes électriques
                pour les professionnels et les collectivités.
              </p>
              <div className="domo-intro-tags">
                <span><i className="fas fa-check-circle"></i> Qualité</span>
                <span><i className="fas fa-check-circle"></i> Sécurité</span>
                <span><i className="fas fa-check-circle"></i> Performance</span>
              </div>
            </div>
            <div className="domo-intro-right">
              <img src="/images/Imagedomoelecfinale.jpg" alt="DOMOELEC" />
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Stats band */}
      <section className="domo-stats">
        <div className="container">
          <div className="domo-stats-grid">
            <div className="domo-stat-item">
              <strong>+13</strong>
              <span>Années d'expérience</span>
            </div>
            <div className="domo-stat-item">
              <strong>500+</strong>
              <span>Projets réalisés</span>
            </div>
            <div className="domo-stat-item">
              <strong>2000+</strong>
              <span>Produits</span>
            </div>
            <div className="domo-stat-item">
              <strong>24h</strong>
              <span>Intervention d'urgence</span>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Citation */}
      <section className="domo-quote-section">
        <div className="container">
          <div className="domo-quote-card">
            <i className="fas fa-quote-left domo-quote-icon"></i>
            <blockquote>
              Après plus de 13 ans d'expérience dans le courant faible, nous avons développé une expertise
              unique qui nous permet de proposer des solutions sur mesure. Notre mission : révolutionner
              les installations électriques — plus intelligentes, plus durables et toujours conformes
              aux normes de sécurité les plus strictes.
            </blockquote>
            <div className="domo-quote-author">
              <div className="domo-quote-avatar">TE</div>
              <div>
                <strong>TARIK ELBOURZQUI</strong>
                <span>Fondateur DOMOELEC</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Valeurs - Timeline */}
      <section className="domo-values">
        <div className="container">
          <div className="domo-values-header">
            <span className="domo-label">Nos engagements</span>
            <h2>Pourquoi choisir <span className="hdr-green">DOMOELEC</span> ?</h2>
          </div>
          <div className="domo-timeline">
            {[
              { icon: 'fas fa-shield-alt', title: 'Sécurité', desc: 'Installations conformes aux normes les plus strictes du marché.' },
              { icon: 'fas fa-award', title: 'Expertise', desc: '+13 ans d\'expérience avec des équipes certifiées.' },
              { icon: 'fas fa-tools', title: 'Maintenance', desc: 'Service préventif et correctif pour garantir la continuité.' },
              { icon: 'fas fa-handshake', title: 'Accompagnement', desc: 'Un interlocuteur dédié du conseil à la mise en service.' },
              { icon: 'fas fa-bolt', title: 'Réactivité', desc: 'Intervention d\'urgence sous 24h sur tout le territoire.' },
              { icon: 'fas fa-cogs', title: 'Innovation', desc: 'Solutions connectées et intelligentes pour vos bâtiments.' },
            ].map((v, i) => (
              <div key={i} className={`domo-tl-item ${i % 2 === 0 ? 'left' : 'right'}`}>
                <div className="domo-tl-dot"><i className={v.icon}></i></div>
                <div className="domo-tl-content">
                  <h3>{v.title}</h3>
                  <p>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 5: CTA */}
      <section className="domo-cta">
        <div className="container">
          <div className="domo-cta-inner">
            <div>
              <h2>Un projet en tête ?</h2>
              <p>Contactez-nous pour une étude personnalisée et un devis gratuit.</p>
            </div>
            <div className="domo-cta-btns">
              <Link to="/contact" className="domo-btn-primary">
                <i className="far fa-paper-plane"></i> Demander un devis
              </Link>
              <a href="tel:0522340659" className="domo-btn-outline">
                <i className="fas fa-phone-volume"></i> 05 22 34 06 59
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Domoelec;
